import { LATAM_AND_BRAZIL_ES_PRO, NO_PROMOTION, promotionKeys, RETAIL_STARTER_PRODUCT, STARTER_SUMMER_2022 } from 'self-service-api/constants/Promotions';
import { getProductForSkuId } from 'pricing-pages-lib/utils/productsUtils';
import { QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { getCrmSuiteLowestTermsOfferId, getOfferIdFromIdByUnitScopeRecord, getOfferInfo } from './offerUtils';
import { PROFESSIONAL, STARTER } from 'self-service-api/constants/ProductLevels';
export const getAllEligiblePromotions = ({
  promotions
}) => {
  if (!promotions) return [];
  const allPromotions = Object.values(promotions.productsEligibleForDirectPromotions || {});
  const uniquePromotions = {};

  for (const promotion of allPromotions) {
    for (const versionSpecificPromotion of Object.values(promotion)) {
      const {
        eligiblePromotion
      } = versionSpecificPromotion;

      if (eligiblePromotion && eligiblePromotion !== NO_PROMOTION) {
        uniquePromotions[eligiblePromotion] = true;
      }
    }
  }

  return Object.keys(uniquePromotions);
};
export const getOffersMap = ({
  promotions: {
    offersById
  }
}) => offersById;
export const getIsLatamEsEligible = ({
  promotions
}) => {
  const eligiblePromotions = getAllEligiblePromotions({
    promotions
  });
  return eligiblePromotions.includes(promotionKeys.LATAM_AND_BRAZIL_ES_PRO);
};
export const getIsHsfxEligible = ({
  promotions
}) => {
  const eligiblePromotions = getAllEligiblePromotions({
    promotions
  });
  return eligiblePromotions.includes(promotionKeys.HSFS_SEED) || eligiblePromotions.includes(promotionKeys.HSFS_SERIES_A) || eligiblePromotions.includes(promotionKeys.HSFX_ENTREPRENEUR) || eligiblePromotions.includes(promotionKeys.HSFX_BOOTSTRAP);
};
const defaultPromotion = {
  dtbOfferIds: [],
  offerIds: [],
  quantityPackOfferIds: {}
};
export const getProductPromotion = ({
  promotions
}, {
  apiName,
  versionNumber
}) => {
  const {
    productsEligibleForDirectPromotions
  } = promotions;
  return productsEligibleForDirectPromotions && productsEligibleForDirectPromotions[apiName] && productsEligibleForDirectPromotions[apiName][versionNumber] || defaultPromotion;
};
export const getPromotionForSkuId = (state, {
  skuId
}) => {
  const {
    productData: {
      skuMap
    }
  } = state;
  const sku = skuMap[skuId];
  let versionNumber;
  if (sku.skuType === QUANTITY_PACK) versionNumber = skuMap[sku.productVersionSkuId].versionNumber;else versionNumber = sku.versionNumber;
  const {
    apiName
  } = getProductForSkuId(state, {
    skuId
  });
  return getProductPromotion(state, {
    apiName,
    versionNumber
  });
};
export const getIsEligibleForRetailPromotion = (state, {
  skuId
}) => {
  const {
    eligiblePromotion
  } = getPromotionForSkuId(state, {
    skuId
  });
  return eligiblePromotion === RETAIL_STARTER_PRODUCT || eligiblePromotion === STARTER_SUMMER_2022;
};
const STARTER_SUITE_SUMMER_PROMO_DISCOUNT = 86.670001;
const STARTER_SUITE_GWP_PROMO_DISCOUNT = 77.777778; // @TODO update with real discount once available

const PRO_SUITE_GWP_PROMO_DISCOUNT = 56.7961;
export const getIsEligibleForSummer2022RetailPromotion = state => {
  const offerId = getCrmSuiteLowestTermsOfferId(state, {
    productLevel: STARTER
  });
  const offerInfo = getOfferInfo(state, {
    offerId: getOfferIdFromIdByUnitScopeRecord(offerId)
  });
  const discount = offerInfo ? offerInfo.discount : 0;
  return discount === STARTER_SUITE_SUMMER_PROMO_DISCOUNT;
};
export const getIsStarterGWP2023Eligible = state => {
  if (!Object.keys(state.promotions).length) return false;
  const offerId = getCrmSuiteLowestTermsOfferId(state, {
    productLevel: STARTER
  });
  const offerInfo = getOfferInfo(state, {
    offerId: getOfferIdFromIdByUnitScopeRecord(offerId)
  });
  const discount = offerInfo ? offerInfo.discount : 0;
  return discount === STARTER_SUITE_GWP_PROMO_DISCOUNT;
};
export const getIsProGWP2023Eligible = state => {
  if (!Object.keys(state.promotions).length) return false;
  const offerId = getCrmSuiteLowestTermsOfferId(state, {
    productLevel: PROFESSIONAL
  });
  const offerInfo = getOfferInfo(state, {
    offerId: getOfferIdFromIdByUnitScopeRecord(offerId)
  });
  const discount = offerInfo ? offerInfo.discount : 0;
  return discount === PRO_SUITE_GWP_PROMO_DISCOUNT;
};
export const getIsEligibleForLatamPromotion = (state, {
  skuId
}) => {
  const {
    eligiblePromotion
  } = getPromotionForSkuId(state, {
    skuId
  });
  return eligiblePromotion && eligiblePromotion === LATAM_AND_BRAZIL_ES_PRO;
};